import { memo } from 'react';
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "PoweredByFooter__StyledDiv",
  componentId: "sc-1axu81s-0"
})(["padding-top:3px;"]);
function PoweredByFooter() {
  return /*#__PURE__*/_jsx(StyledDiv, {
    children: /*#__PURE__*/_jsxs(Small, {
      use: "help",
      children: ["Powered by ", /*#__PURE__*/_jsx("b", {
        children: "Revenue"
      })]
    })
  });
}
export default /*#__PURE__*/memo(PoweredByFooter);